import LendersAPI from '../../../../api/Finance/Lenders'
import AddContract from '../../../../components/Finance/Lender/AddContract/AddContract'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { checkForm } from '../../../../modules/Utils'
import { get, isEmpty, omit, pick } from 'lodash'
import React, { useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'

const api = new LendersAPI()

function AddContractCont(props) {
  const key = props.match.params.key
  const contractKey = get(props.match, 'params.contractKey')
  const type = get(props.match, 'params.contractKey') ? 'update' : 'new'

  const [currentStep, setCurrentStep] = useState(0)
  const [showSkip, setShowSkip] = useState(false)

  const { data: contract, setData: setContract } = useFetchURL(
    `foxxapi/lenderContracts/${contractKey}`,
    [contractKey],
    isEmpty(contractKey)
  )

  const { data: member, fetching: fetchingMember } = useFetchURL(`foxxapi/members/${key}`)
  const { data: lender } = useFetchURL(`foxxapi/lenders/${key}/member`)

  const overviewCmpRef = useRef()
  const BankDetailsCmp = useRef()
  const communicationCmpRef = useRef()
  const keyTermsCmpRef = useRef()

  function prev() {
    setCurrentStep((currentStep) => currentStep - 1)
    setShowSkip(false)
  }

  async function next() {
    setShowSkip(true)

    let valid = false
    switch (currentStep) {
      case 0:
        valid = await checkForm(overviewCmpRef)
        break
      case 1:
        valid = await checkForm(keyTermsCmpRef)
        break
      case 2:
        valid = await checkForm(communicationCmpRef)
        break
      case 3:
        valid = await checkForm(BankDetailsCmp)
        break

      default:
        valid = false
    }

    if (valid) {
      setCurrentStep((currentStep) => currentStep + 1)
      setContract({ ...contract, ...valid })
    }
  }

  function skip() {
    setCurrentStep((currentStep) => currentStep + 1)
    setShowSkip(false)
  }

  const [submitting, _submit] = useSubmit(api.contracts.create)

  async function submit() {
    let bank = await checkForm(BankDetailsCmp)
    bank = { ...bank.bank, accountType: bank.accountType }
    let newData = { ...contract, bank }
    newData.lender = { ...pick(lender, ['_id']), ...newData.lender, type: 'lender' }

    const submitted = await _submit(newData)
    if (submitted)
      props.history.push({
        pathname: `/finance/lenders/${key}/`,
        hash: 'contracts',
      })
  }

  const [updating, _update] = useSubmit(api.contracts.update)

  async function update() {
    let bank = await checkForm(BankDetailsCmp)
    bank = { ...bank.bank, accountType: bank.accountType }
    let newData = { ...contract, bank }
    newData.lender = { ...pick(lender, ['_id']), ...newData.lender, type: 'lender' }

    const updated = await _update(omit(newData, ['code', 'status', 'revision', 'paid', 'invoiced', '_history']))

    if (updated)
      props.history.push({
        pathname: `/finance/lenders/${key}/`,
        hash: 'contracts',
      })
  }

  return (
    <AddContract
      {...{
        type,
        member,
        lender,
        fetchingMember,
        submitting,
        contract,
        skip,
        next,
        prev,
        submit,
        update,
        updating,
        communicationCmpRef,
        overviewCmpRef,
        key,
        showSkip,
        currentStep,
        // updateContract,
        BankDetailsCmp,
        keyTermsCmpRef,
      }}
    />
  )
}

export default withRouter(AddContractCont)
